
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.68 7.802a.187.187 0 00.126.17 2.968 2.968 0 012.008 2.805V13a.37.37 0 01-.37.37h-.662a.184.184 0 00-.184.17l-.267 3.194a.37.37 0 01-.37.339h-2.22a.37.37 0 01-.37-.339l-.267-3.194a.185.185 0 00-.184-.17h-.662a.37.37 0 01-.37-.37v-2.223a2.968 2.968 0 012.008-2.804.187.187 0 00.013-.35 2.408 2.408 0 111.884 0 .187.187 0 00-.113.18zm8.06 10.976c0 .668-.864 2.222-8.889 2.222-2.672 0-8.888-.217-8.887-2.222 0-.48 0-1.603 5.25-2.07a.74.74 0 11.13 1.476c-.94.072-1.876.21-2.797.415a.185.185 0 000 .36 29.21 29.21 0 006.304.56c2.116.042 4.23-.145 6.306-.56a.185.185 0 000-.36 20.17 20.17 0 00-2.828-.418.74.74 0 11.13-1.476c5.28.466 5.28 1.592 5.28 2.073zM6.434 8.709a.188.188 0 01-.016-.346 2.037 2.037 0 10-1.725 0 .188.188 0 01-.016.346 2.597 2.597 0 00-1.715 2.438v1.112a.37.37 0 00.37.37h.615c.094 0 .173.072.183.165l.315 2.84c.023.186.18.328.369.33h1.48a.37.37 0 00.37-.33l.315-2.84a.185.185 0 01.184-.165h.613a.37.37 0 00.37-.37v-1.113A2.595 2.595 0 006.436 8.71zm12.469-.168a.188.188 0 00.122.168 2.595 2.595 0 011.716 2.438v1.112a.37.37 0 01-.37.37h-.614a.185.185 0 00-.184.165l-.316 2.84a.37.37 0 01-.368.33h-1.481a.375.375 0 01-.369-.33l-.315-2.84a.186.186 0 00-.184-.165h-.614a.37.37 0 01-.37-.37v-1.112A2.596 2.596 0 0117.27 8.71a.188.188 0 00.016-.346 2.037 2.037 0 111.725 0 .188.188 0 00-.107.178z","fill":"#F68B1F"}})])
          )
        }
      }
    